module.exports = __webpack_public_path__ + "static/media/4434.b58980a0.jpg";